export const PERSIST_STATE = "persist:root";
export const IS_LOGGED_IN = "isLoggedIn";

export const DEFAULT_LIMIT = 10;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

export const MANAGE_TYPE = ["Inventory", "Non Inventory"];
export const ITEM_TYPE = [
  "Medicine",
  "Service",
  "Surgery",
  "Procedure",
  "Investigation",
  "Equipment",
  "Room",
  "Other",
];
export const SALE_UNITS = ["number", "pcs", "bundle", "packet", "litre", "kg"];
export const SELLING_TYPE = ["Batch wise", "Batch Serial No", "None"];
export const USAGE_TYPE = ["Consumable", "Asset"];
export const PHARMACY_STATUS = [
  "Available",
  "Expiring",
  "Depleting",
  "Out of Stock",
];

export const PAYMENT_METHOD = [
  "Debit/Credit Card",
  "Cash",
  "Net Banking",
  "QR Code",
  "Cheque",
  "Other",
];
export const PAYMENT_CLEAR_MODE = ["Auto", "Manual"];
export const TRANSACTION_MODE = ["Payment", "Refund", "Other", "Pending Payment"];
export const PAYMENT_CHARGES_TYPE = ["percent", "fixed"];

export const CAPITALIZE = (text) => {
  return text
    ?.split(/[-\s]/)
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    ?.join(" ");
};

const CREATE_ERROR_RESPONSE = (code, message) => ({
  code,
  data: null,
  status: false,
  message,
});

export const GET_ERROR = (error) => {
  const message = error?.response?.data?.message || error?.message;

  if (!error?.response) {
    if (error?.code === "ERR_NETWORK") {
      if (!navigator.onLine) {
        return CREATE_ERROR_RESPONSE(
          1000,
          "You are offline. Please check your internet connection."
        );
      } else {
        return CREATE_ERROR_RESPONSE(1001, "Some error occurred.");
      }
    }
  }

  return CREATE_ERROR_RESPONSE(error?.response?.status, message);
};
